import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-log',
  templateUrl: './subscription-log.component.html',
  styleUrls: ['./subscription-log.component.scss']
})
export class SubscriptionLogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
